import { useQuery } from '@tanstack/react-query';
import invariant from 'tiny-invariant';

import { Search } from '@air/api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

const getPrivateAudioSampleRatesListKey = ({
  workspaceId,
  boardId,
  libraryId,
}: {
  workspaceId: string | undefined;
  boardId: string | undefined;
  libraryId: string | undefined;
}) => ['PRIVATE_AUDIO_SAMPLE_RATES', { workspaceId, boardId, libraryId }];

export const usePrivateAudioSampleRatesList = ({
  boardId,
  libraryId,
}: {
  boardId: string | undefined;
  libraryId: string | undefined;
}) => {
  const { currentWorkspace } = useCurrentWorkspace();

  const key = getPrivateAudioSampleRatesListKey({ workspaceId: currentWorkspace?.id, boardId, libraryId });

  return useQuery({
    queryKey: key,

    queryFn: async () => {
      invariant(currentWorkspace?.id, 'Workspace ID is required');

      const data = await Search.getAssetVersionFilterLookups({
        limit: 50,
        field: 'audioSampleRate',
        workspaceId: currentWorkspace.id,
        boardId,
        libraryId,
      });

      return data.lookups.map(({ value }) => value.toString());
    },
    enabled: !!currentWorkspace?.id,
  });
};
